import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomExceptionService } from 'src/app/errorHandlers/custom-exception.service';
import { CustomerService } from 'src/app/Services/customer.service';
import { ExportUtility } from 'src/assets/js/export-utility';
import { v4 as SessionID } from 'uuid';

@Component({
  selector: 'app-v-customer',
  templateUrl: './v-customer.component.html',
  styleUrls: ['./v-customer.component.css']
})
export class VCustomerComponent implements OnInit {
  ManageCustomersList: any[]
  _IsProgressSpinner: boolean = false;
  CustomerList: any[]
  cols: any[];
  sessionId: string
  _UserName: string
  _RoleName: string

  constructor(private router: Router, private _CustomerService: CustomerService, private _CustomExceptionService: CustomExceptionService,
    public exportUtility: ExportUtility, private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    // if(sessionStorage["username"] == undefined)
    // {
    // this.route.queryParams
    //   .subscribe(params => {
    //     console.log(params); // { orderby: "price" }
    //     sessionStorage["username"] = JSON.stringify(params.username);
    //     sessionStorage["role"] = JSON.stringify(params.role);
    //   });
    // }
    // const queryString = window.location.search;
    //   console.log("gopu", queryString);
    //   const urlParams = new URLSearchParams(queryString);
    //   sessionStorage["username"] = JSON.stringify(urlParams.get('username'));
    //   sessionStorage["role"] = JSON.stringify(urlParams.get('role'));
    //   console.log("bha", urlParams.get('username'), urlParams.get('role'));
    this.cols = [
      { field: 'customername', header: 'Customer Name' },
      { field: 'tallyid', header: 'Customer Tally ID' },
      { field: 'companytype', header: 'Company Type' },
      { field: 'istransporter', header: 'Is Transporter' },
      { field: 'pan', header: 'PAN No' },
      { field: 'billingcycle', header: 'Billing Cycle' },
      { field: 'recordstatus', header: 'Status' },

    ]
    //if()
    if(sessionStorage["SessionId"] !=undefined ){
      this._IsProgressSpinner = true;
      this._CustomerService.GetAll().subscribe((result) => {
        this._IsProgressSpinner = false;
        const resultJSON = JSON.parse(JSON.stringify(result));
        if (resultJSON.tranStatus.result == true && (resultJSON != null || resultJSON != undefined)) {
          this.ManageCustomersList = resultJSON.lstCustomer
          // console.log(resultJSON.productviews);
          this.sessionId = SessionID();
          // console.log("session", this.sessionId)
  
  
        }
        else {
          this._CustomExceptionService.handleError(resultJSON.tranStatus.lstErrorItem[0].message);
        }
      });
    }else{
      this._CustomExceptionService.handleError("Your session is time out, Please login to continue");
      return
    }

  }


  GoToCreate(event) {

    this.router.navigate(['/cCustomer']);

  }
  onBeforeUnload() {
    // debugger;
    alert("ok")
  }
  exportExcel() {
    let SalesInvoicePOSList = this.GetVolumeDistributionList();
    this.exportUtility.exportExcel(SalesInvoicePOSList, 'Customers', 'xlsx');
  }

  GetVolumeDistributionList() {
    // if (!this._Saleinvoiceposviews || !this._Saleinvoiceposviews.length)
    //   return;
    let SalesInvoicePOSList = [];
    this.CustomerList = [] = [];
    if (this.ManageCustomersList.length == 0) {
      let volumelist: any = {};
      volumelist["Customer Name"] = "";
      volumelist["Customer Tally ID"] = "";
      volumelist["Company Type"] = "";
      volumelist["Is Transporter"] = "";
      volumelist["PAN No"] = "";
      volumelist["Billing Cycle"] = "";
      volumelist["Status"] = "";

      SalesInvoicePOSList.push(volumelist);
    }
    this.ManageCustomersList.forEach(element => {
      let volumelist: any = {};
      volumelist["Customer Name"] = element.customername;
      volumelist["Customer Tally ID"] = element.tallyid;
      volumelist["Company Type"] = element.companytype;
      volumelist["Is Transporter"] = element.istransporter;
      volumelist["PAN No"] = element.pan;
      volumelist["Billing Cycle"] = element.billingcycle;
      volumelist["Status"] = element.recordstatus;

      SalesInvoicePOSList.push(volumelist);
    });



    return SalesInvoicePOSList;
  }
}
